module.exports = __webpack_public_path__ + "static/media/credit-card_discover.bdfc6f0d.svg";